import styled from 'styled-components';

export const TrainingStoreModalContainer = styled.div`
  padding: 20% 12%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex: 1;
  width: 100%;

  button {
    width: 100%;
    height: 58px;
    background: transparent linear-gradient(97deg, #ffd503 0%, #ffdf22 100%) 0%
      0% no-repeat padding-box;
    border-radius: 1.8rem;

    font-size: 2.4rem;
    font-weight: bold;

    :last-child {
      background: transparent linear-gradient(97deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      opacity: 1;
      color: white;
    }
  }
`;

export const Container = styled.div`
  padding: 7.2rem 3.1rem;

  display: flex;
  flex-wrap: wrap;
`;

export const Navigator = styled.button`
  width: 50.9rem;
  height: 8rem;
  border-radius: 0.4rem;
  background-color: #fff;

  margin-right: 6.4rem;
  margin-bottom: 4.9rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 4.2rem;
  }

  svg {
    transform: scaleX(-1);
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3.2rem;

  cursor: pointer;

  transition: filter 0.3s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const NavigatorTitle = styled.span`
  font-size: 2.4rem;
  font-weight: bold;
`;
